import { User } from '../../models/user.model';
import * as fromActions from '../actions/user.actions';

export interface UserState {
  loading: boolean;
  loaded: boolean;
  data: User;
  creationError: string;
}

export const initialState: UserState = {
  loading: false,
  loaded: false,
  data: <User>{},
  creationError: '',
};

export function userReducer(
  state: UserState = initialState,
  action: fromActions.UserAction,
): UserState {
  switch (action.type) {
    case fromActions.LOAD_USER: {
      return { ...state, loading: true };
    }

    case fromActions.LOAD_USER_SUCCESS: {
      const data: User = action.payload;
      return { ...state, data, loading: false, loaded: true };
    }

    case fromActions.LOAD_USER_FAIL: {
      return { ...state, loading: false, loaded: false };
    }

    case fromActions.CREATE_NEW_USER: {
      const data: User = action.payload;
      return {
        ...state,
        data,
        loading: true,
        loaded: false,
        creationError: '',
      };
    }

    case fromActions.CREATE_NEW_USER_SUCCESS: {
      return { ...state, loading: false, loaded: true };
    }

    case fromActions.CREATE_NEW_USER_FAIL: {
      const msg: string = action?.payload?.errorMsg;
      return { ...state, loading: false, loaded: true, creationError: msg };
    }

    case fromActions.UPDATE_USER_DATA: {
      const data: any = action.payload;
      return { ...state, data, loading: true };
    }

    case fromActions.UPDATE_USER_DATA_SUCCESS: {
      const data: User = action.payload;
      return { ...state, data, loading: false, loaded: true };
    }

    case fromActions.UPDATE_USER_DATA_FAIL: {
      return { ...state, loading: false, loaded: false };
    }

    default:
      return state;
  }
}

export const selectUserData = (state: UserState) => state.data;
export const selectUserLoading = (state: UserState) => state.loading;
export const selectUserLoaded = (state: UserState) => state.loaded;
